// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Montserrat:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   HAUTÉ BEAUTÉ LAB NAVBAR
========================= */

:root {
  --royal-pink: #e6007e;
  --royal-pink-light: #ff4da6;
  --black: #050505;
  --metal-black: #111113;
  --pearl: #f8f5f2;
  --pearl-muted: #d8d3d0;
}

/* =========================
   NAVBAR
========================= */

.navbar {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;

  background: linear-gradient(
    115deg,
    #030303 0%,
    #111113 45%,
    #050505 100%
  );

  border-bottom: 1px solid rgba(255, 255, 255, 0.09);

  box-shadow:
    0 8px 35px rgba(0, 0, 0, 0.35);
}

/* =========================
   INNER CONTAINER
========================= */

.nav-container {
  width: min(94%, 1450px);
  height: 86px;
  margin: 0 auto;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 35px;
}

/* =========================
   BRAND
========================= */

.brand {
  display: flex;
  align-items: baseline;

  text-decoration: none;
  white-space: nowrap;

  transition: opacity 0.3s ease;
}

.brand:hover {
  opacity: 0.9;
}

.brand-haute,
.brand-beaute {
  font-family: "Cormorant Garamond", serif;

  color: var(--pearl);

  font-size: 2rem;
  font-weight: 500;

  line-height: 1;

  letter-spacing: 0.5px;
}

.brand-beaute {
  font-style: italic;
  font-weight: 400;

  margin-left: 3px;
}

.brand-lab {
  font-family: "Montserrat", sans-serif;

  color: var(--royal-pink);

  font-size: 0.57rem;
  font-weight: 500;

  letter-spacing: 4px;

  margin-left: 10px;
}

/* =========================
   NAVIGATION
========================= */

.nav-links {
  display: flex;
  align-items: center;

  gap: 27px;

  margin-left: auto;
}

.nav-link {
  position: relative;

  color: var(--pearl-muted);

  text-decoration: none;
  text-transform: uppercase;

  font-family: "Montserrat", sans-serif;

  font-size: 0.67rem;
  font-weight: 400;

  letter-spacing: 1.8px;

  padding: 10px 0;

  transition:
    color 0.25s ease,
    opacity 0.25s ease;
}

.nav-link:hover {
  color: var(--pearl);
}

/* =========================
   PINK UNDERLINE
========================= */

.nav-link::after {
  content: "";

  position: absolute;

  left: 50%;
  bottom: 1px;

  width: 0;
  height: 1px;

  background: linear-gradient(
    90deg,
    var(--royal-pink),
    var(--royal-pink-light)
  );

  transform: translateX(-50%);

  transition: width 0.3s ease;
}

.nav-link:hover::after,
.nav-link.active::after {
  width: 100%;
}

.nav-link.active {
  color: var(--pearl);
}

/* =========================
   BOOK BUTTON
========================= */

.nav-actions {
  display: flex;
  align-items: center;

  gap: 15px;
}

.book-button,
.mobile-book {
  font-family: "Montserrat", sans-serif;

  text-decoration: none;
  text-transform: uppercase;

  font-size: 0.65rem;
  font-weight: 500;

  letter-spacing: 2px;
}

.book-button {
  color: #ffffff;

  padding: 14px 27px;

  background: linear-gradient(
    135deg,
    #ff3ca0,
    var(--royal-pink),
    #c9006e
  );

  border: 1px solid rgba(255, 255, 255, 0.18);

  box-shadow:
    0 5px 20px rgba(230, 0, 126, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);

  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;
}

.book-button:hover {
  transform: translateY(-2px);

  box-shadow:
    0 8px 30px rgba(230, 0, 126, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

/* =========================
   MOBILE MENU BUTTON
========================= */

.menu-button {
  display: none;

  width: 40px;
  height: 40px;

  background: transparent;

  border: 0;

  cursor: pointer;

  position: relative;
}

.menu-button span {
  position: absolute;

  width: 24px;
  height: 1px;

  left: 8px;

  background: var(--pearl);

  transition: 0.3s ease;
}

.menu-button span:first-child {
  top: 15px;
}

.menu-button span:last-child {
  top: 24px;
}

.menu-active span:first-child {
  transform: translateY(4.5px) rotate(45deg);
}

.menu-active span:last-child {
  transform: translateY(-4.5px) rotate(-45deg);
}

/* MOBILE BOOK BUTTON */

.mobile-book {
  display: none;
}

/* =========================
   TABLET
========================= */

@media (max-width: 1100px) {

  .nav-links {
    gap: 18px;
  }

  .nav-link {
    font-size: 0.62rem;
    letter-spacing: 1.4px;
  }

  .brand-haute,
  .brand-beaute {
    font-size: 1.7rem;
  }

  .brand-lab {
    font-size: 0.52rem;
  }
}

/* =========================
   MOBILE
========================= */

@media (max-width: 900px) {

  .nav-container {
    height: 76px;
  }

  .book-button {
    display: none;
  }

  .menu-button {
    display: block;
  }

  .nav-links {
    position: absolute;

    top: 76px;
    left: 0;

    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: stretch;

    gap: 0;

    margin: 0;

    padding: 25px 6% 35px;

    background: linear-gradient(
      145deg,
      #050505,
      #151517
    );

    border-top: 1px solid rgba(255, 255, 255, 0.08);
    border-bottom: 1px solid rgba(230, 0, 126, 0.3);

    opacity: 0;
    visibility: hidden;

    transform: translateY(-12px);

    transition:
      opacity 0.3s ease,
      transform 0.3s ease,
      visibility 0.3s ease;
  }

  .nav-links.nav-open {
    opacity: 1;
    visibility: visible;

    transform: translateY(0);
  }

  .nav-link {
    padding: 17px 0;

    font-size: 0.72rem;
    font-weight: 400;

    letter-spacing: 2px;

    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  }

  .nav-link::after {
    display: none;
  }

  .mobile-book {
    display: block;

    margin-top: 25px;
    padding: 16px 20px;

    color: white;

    text-align: center;

    background: linear-gradient(
      135deg,
      #ff3ca0,
      var(--royal-pink),
      #c9006e
    );
  }
}

/* =========================
   SMALL MOBILE
========================= */

@media (max-width: 480px) {

  .nav-container {
    width: 91%;
  }

  .brand-haute,
  .brand-beaute {
    font-size: 1.45rem;
  }

  .brand-lab {
    font-size: 0.48rem;

    letter-spacing: 2.5px;

    margin-left: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAI3B;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;2BAE2B;;AAE3B;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;;EAEb;;;;;GAKC;;EAED,kDAAkD;;EAElD;kCACgC;AAClC;;AAEA;;2BAE2B;;AAE3B;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,SAAS;AACX;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,qBAAqB;;EAErB,qBAAqB;EACrB,mBAAmB;;EAEnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,wCAAwC;;EAExC,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;;EAEhB,cAAc;;EAEd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;;EAErC,wBAAwB;;EAExB,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;;EAEnB,SAAS;;EAET,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,yBAAyB;;EAEzB,qBAAqB;EACrB,yBAAyB;;EAEzB,qCAAqC;;EAErC,kBAAkB;EAClB,gBAAgB;;EAEhB,qBAAqB;;EAErB,eAAe;;EAEf;;sBAEoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,WAAW;;EAEX,kBAAkB;;EAElB,SAAS;EACT,WAAW;;EAEX,QAAQ;EACR,WAAW;;EAEX;;;;GAIC;;EAED,2BAA2B;;EAE3B,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;;EAEnB,SAAS;AACX;;AAEA;;EAEE,qCAAqC;;EAErC,qBAAqB;EACrB,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,cAAc;;EAEd,kBAAkB;;EAElB;;;;;GAKC;;EAED,2CAA2C;;EAE3C;;0CAEwC;;EAExC;;yBAEuB;AACzB;;AAEA;EACE,2BAA2B;;EAE3B;;0CAEwC;AAC1C;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;;EAEb,WAAW;EACX,YAAY;;EAEZ,uBAAuB;;EAEvB,SAAS;;EAET,eAAe;;EAEf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,WAAW;;EAEX,SAAS;;EAET,wBAAwB;;EAExB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;AACf;;AAEA;;2BAE2B;;AAE3B;;EAEE;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;2BAE2B;;AAE3B;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;;IAElB,SAAS;IACT,OAAO;;IAEP,WAAW;;IAEX,aAAa;IACb,sBAAsB;IACtB,oBAAoB;;IAEpB,MAAM;;IAEN,SAAS;;IAET,qBAAqB;;IAErB;;;;KAIC;;IAED,+CAA+C;IAC/C,+CAA+C;;IAE/C,UAAU;IACV,kBAAkB;;IAElB,4BAA4B;;IAE5B;;;0BAGsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;;IAEnB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;;IAEf,kBAAkB;IAClB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,kDAAkD;EACpD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;;IAEd,gBAAgB;IAChB,kBAAkB;;IAElB,YAAY;;IAEZ,kBAAkB;;IAElB;;;;;KAKC;EACH;AACF;;AAEA;;2BAE2B;;AAE3B;;EAEE;IACE,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;;IAElB,qBAAqB;;IAErB,gBAAgB;EAClB;AACF","sourcesContent":["/* =========================\n   HAUTÉ BEAUTÉ LAB NAVBAR\n========================= */\n\n@import url(\"https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Montserrat:wght@300;400;500;600&display=swap\");\n\n:root {\n  --royal-pink: #e6007e;\n  --royal-pink-light: #ff4da6;\n  --black: #050505;\n  --metal-black: #111113;\n  --pearl: #f8f5f2;\n  --pearl-muted: #d8d3d0;\n}\n\n/* =========================\n   NAVBAR\n========================= */\n\n.navbar {\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 1000;\n\n  background: linear-gradient(\n    115deg,\n    #030303 0%,\n    #111113 45%,\n    #050505 100%\n  );\n\n  border-bottom: 1px solid rgba(255, 255, 255, 0.09);\n\n  box-shadow:\n    0 8px 35px rgba(0, 0, 0, 0.35);\n}\n\n/* =========================\n   INNER CONTAINER\n========================= */\n\n.nav-container {\n  width: min(94%, 1450px);\n  height: 86px;\n  margin: 0 auto;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  gap: 35px;\n}\n\n/* =========================\n   BRAND\n========================= */\n\n.brand {\n  display: flex;\n  align-items: baseline;\n\n  text-decoration: none;\n  white-space: nowrap;\n\n  transition: opacity 0.3s ease;\n}\n\n.brand:hover {\n  opacity: 0.9;\n}\n\n.brand-haute,\n.brand-beaute {\n  font-family: \"Cormorant Garamond\", serif;\n\n  color: var(--pearl);\n\n  font-size: 2rem;\n  font-weight: 500;\n\n  line-height: 1;\n\n  letter-spacing: 0.5px;\n}\n\n.brand-beaute {\n  font-style: italic;\n  font-weight: 400;\n\n  margin-left: 3px;\n}\n\n.brand-lab {\n  font-family: \"Montserrat\", sans-serif;\n\n  color: var(--royal-pink);\n\n  font-size: 0.57rem;\n  font-weight: 500;\n\n  letter-spacing: 4px;\n\n  margin-left: 10px;\n}\n\n/* =========================\n   NAVIGATION\n========================= */\n\n.nav-links {\n  display: flex;\n  align-items: center;\n\n  gap: 27px;\n\n  margin-left: auto;\n}\n\n.nav-link {\n  position: relative;\n\n  color: var(--pearl-muted);\n\n  text-decoration: none;\n  text-transform: uppercase;\n\n  font-family: \"Montserrat\", sans-serif;\n\n  font-size: 0.67rem;\n  font-weight: 400;\n\n  letter-spacing: 1.8px;\n\n  padding: 10px 0;\n\n  transition:\n    color 0.25s ease,\n    opacity 0.25s ease;\n}\n\n.nav-link:hover {\n  color: var(--pearl);\n}\n\n/* =========================\n   PINK UNDERLINE\n========================= */\n\n.nav-link::after {\n  content: \"\";\n\n  position: absolute;\n\n  left: 50%;\n  bottom: 1px;\n\n  width: 0;\n  height: 1px;\n\n  background: linear-gradient(\n    90deg,\n    var(--royal-pink),\n    var(--royal-pink-light)\n  );\n\n  transform: translateX(-50%);\n\n  transition: width 0.3s ease;\n}\n\n.nav-link:hover::after,\n.nav-link.active::after {\n  width: 100%;\n}\n\n.nav-link.active {\n  color: var(--pearl);\n}\n\n/* =========================\n   BOOK BUTTON\n========================= */\n\n.nav-actions {\n  display: flex;\n  align-items: center;\n\n  gap: 15px;\n}\n\n.book-button,\n.mobile-book {\n  font-family: \"Montserrat\", sans-serif;\n\n  text-decoration: none;\n  text-transform: uppercase;\n\n  font-size: 0.65rem;\n  font-weight: 500;\n\n  letter-spacing: 2px;\n}\n\n.book-button {\n  color: #ffffff;\n\n  padding: 14px 27px;\n\n  background: linear-gradient(\n    135deg,\n    #ff3ca0,\n    var(--royal-pink),\n    #c9006e\n  );\n\n  border: 1px solid rgba(255, 255, 255, 0.18);\n\n  box-shadow:\n    0 5px 20px rgba(230, 0, 126, 0.25),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n\n  transition:\n    transform 0.25s ease,\n    box-shadow 0.25s ease;\n}\n\n.book-button:hover {\n  transform: translateY(-2px);\n\n  box-shadow:\n    0 8px 30px rgba(230, 0, 126, 0.45),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n/* =========================\n   MOBILE MENU BUTTON\n========================= */\n\n.menu-button {\n  display: none;\n\n  width: 40px;\n  height: 40px;\n\n  background: transparent;\n\n  border: 0;\n\n  cursor: pointer;\n\n  position: relative;\n}\n\n.menu-button span {\n  position: absolute;\n\n  width: 24px;\n  height: 1px;\n\n  left: 8px;\n\n  background: var(--pearl);\n\n  transition: 0.3s ease;\n}\n\n.menu-button span:first-child {\n  top: 15px;\n}\n\n.menu-button span:last-child {\n  top: 24px;\n}\n\n.menu-active span:first-child {\n  transform: translateY(4.5px) rotate(45deg);\n}\n\n.menu-active span:last-child {\n  transform: translateY(-4.5px) rotate(-45deg);\n}\n\n/* MOBILE BOOK BUTTON */\n\n.mobile-book {\n  display: none;\n}\n\n/* =========================\n   TABLET\n========================= */\n\n@media (max-width: 1100px) {\n\n  .nav-links {\n    gap: 18px;\n  }\n\n  .nav-link {\n    font-size: 0.62rem;\n    letter-spacing: 1.4px;\n  }\n\n  .brand-haute,\n  .brand-beaute {\n    font-size: 1.7rem;\n  }\n\n  .brand-lab {\n    font-size: 0.52rem;\n  }\n}\n\n/* =========================\n   MOBILE\n========================= */\n\n@media (max-width: 900px) {\n\n  .nav-container {\n    height: 76px;\n  }\n\n  .book-button {\n    display: none;\n  }\n\n  .menu-button {\n    display: block;\n  }\n\n  .nav-links {\n    position: absolute;\n\n    top: 76px;\n    left: 0;\n\n    width: 100%;\n\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    gap: 0;\n\n    margin: 0;\n\n    padding: 25px 6% 35px;\n\n    background: linear-gradient(\n      145deg,\n      #050505,\n      #151517\n    );\n\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    border-bottom: 1px solid rgba(230, 0, 126, 0.3);\n\n    opacity: 0;\n    visibility: hidden;\n\n    transform: translateY(-12px);\n\n    transition:\n      opacity 0.3s ease,\n      transform 0.3s ease,\n      visibility 0.3s ease;\n  }\n\n  .nav-links.nav-open {\n    opacity: 1;\n    visibility: visible;\n\n    transform: translateY(0);\n  }\n\n  .nav-link {\n    padding: 17px 0;\n\n    font-size: 0.72rem;\n    font-weight: 400;\n\n    letter-spacing: 2px;\n\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n  }\n\n  .nav-link::after {\n    display: none;\n  }\n\n  .mobile-book {\n    display: block;\n\n    margin-top: 25px;\n    padding: 16px 20px;\n\n    color: white;\n\n    text-align: center;\n\n    background: linear-gradient(\n      135deg,\n      #ff3ca0,\n      var(--royal-pink),\n      #c9006e\n    );\n  }\n}\n\n/* =========================\n   SMALL MOBILE\n========================= */\n\n@media (max-width: 480px) {\n\n  .nav-container {\n    width: 91%;\n  }\n\n  .brand-haute,\n  .brand-beaute {\n    font-size: 1.45rem;\n  }\n\n  .brand-lab {\n    font-size: 0.48rem;\n\n    letter-spacing: 2.5px;\n\n    margin-left: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
